export default __webpack_public_path__ + "static/media/fountain-pen-3.fe16472e.svg";